export const isWithdrawalVisible = (contract) =>
  Boolean(contract?.withdrawal_available && contract?.status !== "withdrawn");

export const canCancelAtPeriodEnd = (contract) =>
  Boolean(
    contract?.status === "active" &&
    /^\d{4}-\d{2}-\d{2}/.test(contract?.paid_until || "") &&
    !contract?.archived_at
  );

const berlinDateOnly = (value = new Date()) => {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Europe/Berlin",
  }).format(parsed);
};

export const canRevokeCancellation = (contract, today = new Date()) => {
  const currentDate = berlinDateOnly(today);
  const paidUntil = contract?.paid_until?.slice?.(0, 10);
  return Boolean(
    contract?.status === "cancel_at_period_end" &&
    /^\d{4}-\d{2}-\d{2}$/.test(paidUntil || "") &&
    currentDate &&
    currentDate <= paidUntil &&
    !contract?.archived_at
  );
};

export const cancellationChannelLabel = (channel) => ({
  customer_portal: "Kundenportal",
  email: "E-Mail",
  whatsapp: "WhatsApp",
  phone: "Telefon",
  admin_portal: "Admin-Erfassung",
  other: "Sonstiges",
}[channel] || "Sonstiges");

export const formatContractDate = (value) => {
  if (value === null || value === undefined || value === "") return "–";
  if (typeof value === "string") {
    const dateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnly) {
      const [, year, month, day] = dateOnly;
      const parsed = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
      if (
        parsed.getUTCFullYear() !== Number(year) ||
        parsed.getUTCMonth() !== Number(month) - 1 ||
        parsed.getUTCDate() !== Number(day)
      ) return "–";
      return `${day}.${month}.${year}`;
    }
  }
  const parsed = value instanceof Date ? value : new Date(value);
  if (!(parsed instanceof Date) || Number.isNaN(parsed.getTime())) return "–";
  return new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Europe/Berlin",
  }).format(parsed);
};

export const formatContractPeriod = (start, end) => {
  const formattedStart = formatContractDate(start);
  const formattedEnd = formatContractDate(end);
  return formattedStart === "–" || formattedEnd === "–"
    ? "–"
    : `${formattedStart} – ${formattedEnd}`;
};

export const paymentPeriodLabel = (payment) =>
  payment?.period_start && payment?.period_end
    ? formatContractPeriod(payment.period_start, payment.period_end)
    : null;

export const contractPaymentDue = (contract) =>
  contract?.next_payment_due || contract?.migration?.next_payment_due || null;

export const contractDisplayPeriod = (contract) => {
  const period = contract?.current_period || contract?.billing_period;
  if (period?.start && period?.end) return period;
  if (contract?.terms?.period_start && contract?.terms?.period_end) {
    return { start: contract.terms.period_start, end: contract.terms.period_end };
  }
  return null;
};

export const paymentAmountCents = (contract, department) => {
  const contractCents = contract?.terms?.price_cents;
  if (Number.isInteger(contractCents) && contractCents > 0) return contractCents;
  return Math.round(Number(department?.betrag || 0) * 100);
};

export const isManuallyBlocked = (record = {}) =>
  Boolean(record.manual_blocked_at) || record.access_status_reason === "admin_blocked";

export const documentedAccessLabel = (record) =>
  isManuallyBlocked(record) ? "Als gesperrt dokumentiert" : "Freigegeben";
